import BaseInputsContainer from "../../../../components/formsAndTable/forms/formControls/baseInput";

const BaseInput = () => {
  return <BaseInputsContainer />;
};

export default BaseInput;
